import { useEffect, useMemo, useRef } from 'react';

import { useChartContext } from '@/components/Chart/context/ChartContext';
import useSeriesVisibility from '@/components/Chart/hooks/useSeriesVisibility';
import type { ChartRef, ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

import useFullScreenOptions from '../hooks/options/useFullScreenOptions';

const useFullScreenChart = ({
  chartSeries,
  isDataHub,
  isLightMode
}: {
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
  isDataHub?: boolean;
  isLightMode: boolean;
}) => {
  const chartComponentRef = useRef<ChartRef | null>(null);
  const chartHeight = window.innerHeight - (isDataHub ? 460 : 260);
  const { createOptions } = useFullScreenOptions({ height: chartHeight, isDataHub, isLightMode });
  const { hiddenSeriesIds, toggleSeriesVisibility } = useSeriesVisibility(chartSeries);

  const options = useMemo(
    () => chartSeries && createOptions(chartSeries, hiddenSeriesIds),
    [chartSeries, createOptions, hiddenSeriesIds]
  );

  const { setChartSeries } = useChartContext();

  useEffect(() => {
    setChartSeries(chartSeries);
  }, [chartSeries, setChartSeries]);

  return { options, chartComponentRef, toggleSeriesVisibility };
};

export default useFullScreenChart;
